import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGrowth: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconGrowth"><Path d="M3.5 3C3.22386 3 3 3.22386 3 3.5V5C3 9.14214 6.35786 12.5 10.5 12.5H11.5V20.5C11.5 20.7761 11.7239 21 12 21C12.2761 21 12.5 20.7761 12.5 20.5V15.5H13.5C17.6421 15.5 21 12.1421 21 8V6.5C21 6.22386 20.7761 6 20.5 6H19C16.199 6 13.7567 7.53544 12.4687 9.81053C12.1207 5.99157 8.90969 3 5 3H3.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGrowth;
